<template>
  <div class="cart">
    <!-- Body -->
    <div class="cart__body">
      <ul class="cart__items">
        <cart-product
          class="cart__item"
          :editable="editable"
          :item="item" 
          :key="i" 
          v-for="(item, i) in cart.items"
          />
      </ul>
    </div>

    <!-- Footer (total) -->
    <footer class="cart__footer">
      <ul v-if="editable" class="cart__items">
        <li class="cart__item cart-fee">
          <div class="cart-fee__label">{{ $t('sayl-oat.cart_footer_subtotal') }}</div>
          <div class="cart-fee__label">{{ $n(total, 'currency') }}</div>
        </li>
      </ul>
      <ul v-else class="cart__items">
        <li class="cart__item cart-fee">
          <div class="cart-fee__label">{{ $t('sayl-oat.cart_footer_subtotal') }}</div>
          <div class="cart-fee__label">{{ $n(cart.subtotal, 'currency') }}</div>
        </li>

        <li class="cart__item cart-fee">
          <div class="cart-fee__label">{{ $t('sayl-oat.cart_footer_vat') }}</div>
          <div class="cart-fee__label">{{ $n(cart.vat, 'currency') }}</div>
        </li>

        <li class="cart__item cart-fee -total">
          <div class="cart-fee__label">{{ $t('sayl-oat.cart_footer_total') }}</div>
          <div class="cart-fee__label">{{ $n(cart.computedTotal, 'currency') }}</div>
        </li>
      </ul>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import CartProduct from './cart-product'

export default {
  name: 'CatalogCart',
  components: {
    CartProduct,
  },

  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState({
      cart: state => state['sayl-oat'].cart
    }),

    total() {
      let ret = this.cart.total.value;
      // if(this.cart.total.promo !== null) {
      //   ret = this.cart.total.promo;
      // }
      return ret;
    }
  }
}
</script>
